<template>
  <div>
    <div  style="padding: 20px; height:800px; overflow: auto;padding-bottom:100px">
      <Tabs value="name1">
        <TabPane label="设置" name="name1">
          <Row>
            <Col span="14">
              <Alert>
                <i-switch v-model="code" @on-change="arriveChange" :disabled="ifclick">
                  <span slot="open">On</span>
                  <span slot="close">Off</span>
                </i-switch>
                <span style="padding-left: 10px">自动生成条形码</span>
              </Alert>
              <Alert>
                <i-switch v-model="iscpriceflag" @on-change="updateShopIsCprice">
                  <span slot="open">On</span>
                  <span slot="close">Off</span>
                </i-switch>
                <span style="padding-left: 10px">采购平均价 </span>
                <span style="color: #cccccc">( 开启后不可进行负库存采购 ) </span>
              </Alert>
              <Alert>
                <i-switch v-model="voiceenbdate" @on-change="updateShopVoiceenbdate">
                  <span slot="open">On</span>
                  <span slot="close">Off</span>
                </i-switch>
                <span style="padding-left: 10px">禁止负库存销售 </span>
                <span style="color: #cccccc">( 开启后不可进行负库存销售 ) </span>
              </Alert>
            </Col>
            <!-- <Col span="5"  offset="1">
                            <Alert>
                                <i-switch  v-model="notice">
                                    <span slot="open">On</span>
                                    <span slot="close">Off</span>
                                </i-switch>  <span style="padding-left: 10px">消息通知</span>
                            </Alert>
            </Col>-->
          </Row>
        </TabPane>
        <TabPane label="打印模板" name="name2">
          <RadioGroup v-model="templateItem" @on-change="definedDate">
            <Radio
              border
              v-for="(item,index) in templateList" :key=index
              :label="item.id"
              style="padding-right:20px"
            >{{item.templatename}}</Radio>
          </RadioGroup>
          <div class="telpbox">
            <Row>
              <Col span="16">
                <Card class="staff_item">
                  <p slot="title" align="left">{{templatechild.templatename}}</p>
                  <div class="item" v-for="(item,index) in templatechild.printNames" :key=index>
                    <Row>
                      <Col span="6">{{item.printname}}</Col>
                      <Col span="15">
                        <Input
                          v-if="item.id==10"
                          v-model="templatechild.qrcode"
                          placeholder="请输入信息"
                          style="width:90%"
                        />
                        <Input
                          v-else-if="item.id==11"
                          v-model="templatechild.remark"
                          placeholder="请输入信息"
                          style="width:90%"
                        />
                        <span v-else>&nbsp</span>
                      </Col>
                      <Col span="3">
                        <i-switch v-model="item.status==1" @on-change="statusChange(item)">
                          <span slot="open">On</span>
                          <span slot="close">Off</span>
                        </i-switch>
                      </Col>
                    </Row>
                  </div>
                  <div class="item">
                    <Row>
                      <Col span="6">描述</Col>
                      <Col span="15">
                        <Input
                          v-model="templatechild.qrcoderemark"
                          placeholder="请输入二维码描述"
                          style="width:90%"
                        />
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Col>
              <Col span="8">
                <Card style="width:260px">
                  <p slot="title">预览</p>
                  <div style="padding-left:65px">
                    <div id="qrcode"></div>
                    <p style="padding:5px 0;">{{templatechild.qrcoderemark}}</p>
                  </div>
                </Card>
                <div class="submitbtn_box">
                  <Button type="primary" class="submitbtn" @click="save">保存</Button>
                </div>
              </Col>
            </Row>
          </div>
          <div class="telpbox" v-if="isWhereSel==2"></div>
        </TabPane>
        <TabPane label="关于" name="name3">
          <Card style="width:420px;margin:100px auto;padding:20px">
            <div style="text-align:center">
              <img class="logo" src="../../assets/img/logo.png" />
              <p style="padding:10px">掌大师</p>
              <h3 style="padding:10px">| ERP进销存管理系统 |</h3>
              <p style="padding:10px">系统版本号: v4.2.0</p>
              <p style="padding:10px">客服电话: 4008016580</p>
            </div>
          </Card>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  components: { QRCode },
  data() {
    return {
      cid: "",
      sid: "",
      notice: false,
      code: false,
      isflag: true,
      ifclick: false,
      templateList: [],
      templateItem: "",
      templatechild: {},
      isWhereSel: "1",
      text: "",
      iscpriceflag:false,//采购平均价开关
      voiceenbdate:false,//负库存销售开关0关1开
    };
  },
  created: function() {
    this.cid = JSON.parse(localStorage.getItem("shop")).cid;
    this.sid = JSON.parse(localStorage.getItem("shop")).id;
     var cprice = JSON.parse(localStorage.getItem("shop")).iscprice;
      if(cprice==0){
        this.iscpriceflag=false
      }else {
        this.iscpriceflag=true
      }
    //DOM更新完之前请求数据
    var isdel = JSON.parse(localStorage.getItem("shop")).iscreatebarcode;
    if (isdel == 0) {
      this.code = false;
    } else {
      this.code = true;
    }
    //DOM更新完之前请求数据
    var voiceenbdate = JSON.parse(localStorage.getItem("shop")).voiceenbdate;
    if (voiceenbdate == 1) {
      this.voiceenbdate = true;
    } else {
      this.voiceenbdate = false;
    }

    // 用户是否可修改自动生成条码
    var PermisCode = JSON.parse(sessionStorage.getItem("access")).code;
    if (!PermisCode.includes("110")) {
      this.ifclick = true;
    }
    this.getPTemplates();
  },

  methods: {
    //采购平均价
    updateShopIsCprice(){
      var isdelloc=0
      if(this.iscpriceflag){
        isdelloc=1
      }else {
        isdelloc=0
      }
      this.$Api.updateShopIsCprice({
        id:this.sid,
        iscprice:isdelloc
      }).then(res => {
        var shop = JSON.parse(localStorage.getItem("shop"));
        shop.iscprice = isdelloc;
        console.log( shop.iscprice)
        localStorage.setItem("shop", JSON.stringify(shop));

      });
    },
    //负库存销售开关0关1开
    updateShopVoiceenbdate(){
      var voiceenbdate=0
      if(this.voiceenbdate){
        voiceenbdate=1
      }else {
        voiceenbdate=0
      }
      this.$Api.updateShopVoiceenbdate({
        id:this.sid,
        voiceenbdate:voiceenbdate
      }).then(res => {
        var shop = JSON.parse(localStorage.getItem("shop"));
        shop.voiceenbdate = voiceenbdate;
        console.log( shop.voiceenbdate)
        localStorage.setItem("shop", JSON.stringify(shop));

      });
    },
    //修改条码
    arriveChange() {
      var isdels = 0;
      if (this.code) {
        isdels = 1;
      } else {
        isdels = 0;
      }
      this.$Api
        .isCreateBarCodeShop({
          id: JSON.parse(localStorage.getItem("shop")).id,
          iscreatebarcode: isdels
        })
        .then(res => {
          if (res.code == 200) {
            var shop = JSON.parse(localStorage.getItem("shop"));
            shop.iscreatebarcode = isdels;
            localStorage.setItem("shop", JSON.stringify(shop));
            this.$Message.success("修改成功");
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //获取打印模板
    getPTemplates() {
      this.$Api
        .getPTemplates({
          cid: this.cid,
          sid: this.sid
        })
        .then(res => {
          if (res.code == 200) {
            this.templateList = res.data;
            this.templateItem = res.data[0].id;
            this.getPTemplatesByid(this.templateItem);
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    definedDate(data) {
      this.templateList.forEach(item => {
        if (item.id == data) {
          this.isWhereSel = item.printtype;
        }
      });
      this.getPTemplatesByid(data);
    },
    //修改状态
    statusChange(item) {
      if (item.status == 1) {
        item.status = 0;
      } else {
        item.status = 1;
      }
    },
    //获取当前id的内容
    getPTemplatesByid(id) {
      this.$Api
        .getPTemplatesByid({
          id: id
        })
        .then(res => {
          if (res.code == 200) {
            this.templatechild = res.data;
            this.qrcode(this.templatechild.qrcode);
          } else {
            this.$Message.warning(res.msg);
          }
        });
    },
    //二维码生成函数
    qrcode(data) {
      document.getElementById("qrcode").innerHTML = "";
      let qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100, // 高度  [图片上传失败...(image-9ad77b-1525851843730)]
        text: data // 二维码内容
      });
    },
    //销售打印模板保存
    save() {
      let strIds = [];
      this.templatechild.printNames.forEach(item => {
        if (item.status == 1) {
          strIds.push(item.id);
        }
      });
      strIds = strIds.join(",");
      this.$Api
        .updatePTemplatesByid({
          id: this.templateItem, //当前模板id
          printids: strIds,
          templatename: this.templatechild.templatename,
          remark: this.templatechild.remark,
          qrcode: this.templatechild.qrcode,
          qrcoderemark: this.templatechild.qrcoderemark
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success("修改成功");
            this.getPTemplatesByid(this.templateItem);
          } else {
            this.$Message.warning(res.msg);
          }
        });
    }
  }
};
</script>


<style  lang="scss" scoped>
.server-title {
  display: inline-block;
  text-align: center;
  width: 88%;
}
.logo {
  width: 50px;
  height: 50px;
  margin: auto;
}
.ivu-form-item {
  height: 30px;
}
.telpbox {
  margin-top: 30px;
}
.staff_item {
  margin-bottom: 25px;
  width: 500px;
  .item {
    padding: 10px 0;
    border-top: 1px solid #f0f0f0;
  }
}
.submitbtn_box {
  width: 260px;
  text-align: center;
}
.submitbtn {
  margin: 10px auto;
}
</style>